import { createIndexedDB, type IndexedDBAPI, type IndexedDBOptions } from './indexedDB'

type Key = string
type Entry = { api: IndexedDBAPI<unknown>; refs: number }

const registry = new Map<Key, Entry>()

const keyOf = (
  opts: Pick<IndexedDBOptions, 'dbName' | 'storeName' | 'dbVersion'> = {}
) => {
  const dbName = opts.dbName ?? 'default-db'
  const storeName = opts.storeName ?? 'default-store'
  const dbVersion = opts.dbVersion ?? 1
  return `${dbName}::${storeName}::${dbVersion}`
}

export const acquireIndexedDB = <T = unknown>(
  opts: IndexedDBOptions = {}
): IndexedDBAPI<T> => {
  const k = keyOf(opts)
  const existing = registry.get(k)
  if (existing) {
    existing.refs += 1
    return existing.api as IndexedDBAPI<T>
  }
  const api = createIndexedDB<T>(opts)
  registry.set(k, { api, refs: 1 })
  return api
}

export const releaseIndexedDB = (
  opts: Pick<IndexedDBOptions, 'dbName' | 'storeName' | 'dbVersion'> = {}
) => {
  const k = keyOf(opts)
  const entry = registry.get(k)
  if (!entry) return
  entry.refs -= 1
  if (entry.refs <= 0) {
    try {
      entry.api.destroy()
    } catch (err) {
      console.error('releaseIndexedDB error', err)
    }
    registry.delete(k)
  }
}
